// extracted by mini-css-extract-plugin
module.exports = {"initialScorePage":"InitialScorePage_initialScorePage__jB9uY","initialScorePage__question":"InitialScorePage_initialScorePage__question__g_ZiW"};